export const dxColumns = [
  'r1_id',
  'account_number',
  'diagnosis_code',
  'is_flat_file_source',
  'is_primary',
  'is_secondary',
  'is_admitting',
];
